<div class="calendar-header mb-3" *ngIf="loggedUser.role_id != 4">
	<div class="grid">
		<div class="col-7">
			<div class="mb-2">Usuario: </div>
			<p-dropdown
			    [style]="{ width: '100%' }"
				[options]="users"
				optionLabel="name_surname_email"
				placeholder="Seleccione"
				optionValue="id"
				appendTo="body"
				[(ngModel)]="user_id"
			></p-dropdown>
		</div>
		<div class="col-3">
			<div class="mb-2">Fechas: </div>
			<p-calendar
			    [style]="{ minWidth: '100%' }"
				[(ngModel)]="rangeDates" 
				dateFormat="dd/mm/yy"
				selectionMode="range" 
				appendTo="body"
				[showButtonBar]="true"
				[readonlyInput]="true"
				(onSelect)="formatSelectedDates()">
			</p-calendar>
		</div>
		<div class="col-2">
			<button
			pButton
			pRipple
			label="Buscar"
			type="button"
			icon="pi pi-search"
			class="p-button-raised p-button-outlined m-1 mt-4"
			(click)="loadReservations();"
		></button>
		</div>
	</div>
</div>

<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5>Facturación</h5>
			<div class="grid">
				<div class="col-3">
					<label>Total</label>
					<h5> {{total}} €</h5>
					
				</div>
				<div class="col-3">
					<label>Total (reservas completadas)</label>
					<h5> {{total_completado}} €</h5>
				</div>
				<div class="col-3">
					<label>Total (reservas no completadas)</label>
					<h5> {{total_no_completado}} €</h5>
				</div>
				<div class="col-3">
					<label>Total (en espera)</label>
					<h5> {{total_en_espera}} €</h5>
				</div>
			</div>
			<p-table
				#dt1
				[value]="reservations"
				dataKey="id"
				[rows]="10"
				[rowHover]="true"
				[paginator]="true"
				sortField="date" 
				[sortOrder]="-1"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button
								pButton
								pRipple
								label="Actualizar"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadReservations(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center" pSortableColumn="date">
							<p-sortIcon field="title"></p-sortIcon>
							Fecha - Hora
						</th>
						<th class="text-center" pSortableColumn="user.name" 
						*ngIf="getUser().role_id != 4">
							<p-sortIcon field="user.name"></p-sortIcon>
							Cliente
						</th>
						<th class="text-center" pSortableColumn="housing.label">
							<p-sortIcon field="housing.label"></p-sortIcon>
							Dirección
						</th>
						<th class="text-center" pSortableColumn="servicesId">
							<p-sortIcon field="servicesId"></p-sortIcon>
							Servicios - Extras
						</th>
						<th class="text-center" pSortableColumn="transaction.total">
							<p-sortIcon field="transaction.total"></p-sortIcon>
							Total €
						</th>
						<th>Estado</th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-reservation>
					<tr>
						<td class="text-center" style="min-width: 5rem">
							{{ reservation.date | date: 'dd/MM/yyyy' }} {{ reservation.time }}
						</td>
						<td class="text-left" style="min-width: 5rem" *ngIf="getUser().role_id != 4">
							<div class="circle-color circle-color-small" [style.background]="'#'+reservation.user.color"></div>
							{{ reservation.user.name }} {{ reservation.user.surname }}<br><small>{{ reservation.user.email }}</small>
						</td>
						<td class="text-left" style="min-width: 5rem">
							{{ reservation.housing.label }} <br>
							{{ reservation.type == 1 ? 'Entrada a piso': 'Salida de piso'}}
						</td>
						<td class="text-left" style="min-width: 5rem">
							<div class="w-100" *ngIf="reservation.services.length > 0 ">
								Servicio: {{reservation.transaction.total_services}} €<br>
								<label class="label" *ngFor="let service of reservation.services">
									{{servicesData[service.service_id] ? servicesData[service.service_id].name : '' }} - 
									{{ service.price | currency: 'EUR'}} <br>
								</label>
							</div>
							<div class="w-100" *ngIf="reservation.extras.length > 0">
								<br>
								Extras: {{reservation.transaction.total_extras}} €<br>
								<label class="label" *ngFor="let extra of reservation.extras">
									{{extrasData[extra.extra_id] ? extrasData[extra.extra_id].name : '' }} - 
									{{extra.price | currency: 'EUR' }} <br>
								</label>
							</div>
						</td>
						<td class="text-left" style="min-width: 5rem">
							<div class="w-100 fw-bold" [ngClass]="reservation.status === 2?'text-success':reservation.status === 0?'text-danger':''">
								{{reservation.transaction.total | currency: 'EUR' }}
							</div>
						</td>
						<td>
							<p-badge *ngIf="reservation.status === 2" value="Completada" severity="success" />
							<p-badge *ngIf="reservation.status === 0" value="No completada" severity="danger" />

							<p-badge *ngIf="reservation.status === 1" value="A la espera" severity="warning" />


						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>